<template>
    <div class="charter-page">
        <header class="charter-hero">
            <div class="charter-hero-content">
                <div class="hero-inner">
                    <h1 class="charter-title">Charte de bonne conduite</h1>
                </div>
            </div>
        </header>

        <main class="charter-container">
            <section class="charter-content">
                <div class="content-box">
                    <div class="charter-intro">
                        <p class="charter-paragraph">
                            L'ensemble des dispositions du présent article constitue la charte de bonne conduite du covoiturage. Cette Charte constitue l'esprit même du service de covoiturage proposé par MyEcoCar. Chaque utilisateur se doit d'être solidaire, responsable et respectueux. Cette Charte est applicable à l'ensemble des utilisateurs du Site et du service proposé par MyEcoCar.
                        </p>
                    </div>

                    <div class="charter-sections">
                        <article class="charter-section">
                            <div class="section-header">
                                <h2 class="section-number">1.</h2>
                                <h2 class="section-title">Le covoiturage</h2>
                            </div>
                            <p class="charter-paragraph section-content">
                                Toute information relative à la Participation aux frais, au Trajet et à toute éventualité, notamment les points de départ et d'arrivée ainsi que les horaires, la tolérance ou la présence de fumeurs, d'animaux ou de musique, et plus généralement tout détail relatif à la logistique, au confort ou aux préférences propres au Trajet ou à l'auteur de l'annonce sont donnés directement par l'utilisateur. En aucun cas la responsabilité de MyecoCar.fr n'est engagée. Le Conducteur s'engage à effectuer le Trajet qu'il a préalablement publié et à voyager avec les Passagers avec qui il a contracté. Enfin, il s'engage à assurer une hygiène minimale. L'acceptation du voyage en commun par le Passager se fait en pleine connaissance de tous ces éléments.
                            </p>
                        </article>

                        <article class="charter-section">
                            <div class="section-header">
                                <h2 class="section-number">2.</h2>
                                <h2 class="section-title">Sécurité et confiance</h2>
                            </div>
                            <p class="charter-paragraph section-content">
                                Le Conducteur s'engage à ne prendre aucun risque au volant et à ne consommer aucun produit dangereux susceptible d'affecter sa capacité à conduire avec vigilance et en toute sécurité. Le Passager ne doit en aucune manière gêner le Conducteur dans sa conduite.
                            </p>
                        </article>

                        <article class="charter-section">
                            <div class="section-header">
                                <h2 class="section-number">3.</h2>
                                <h2 class="section-title">Légalité et transparence</h2>
                            </div>
                            <p class="charter-paragraph section-content">
                                Tout Utilisateur doit pouvoir présenter sans délai ses papiers à un autre Utilisateur dans le cadre du Trajet. Il s'agit du permis de conduire du Conducteur, de la carte grise de son véhicule et de son attestation d'assurance. Lorsqu'un Passager est amené à conduire, il doit pouvoir présenter son permis de conduire. Les identités communiquées à MyEcoCar doivent correspondre à celles du Passager et du Conducteur. Le Conducteur et le véhicule doivent être conformes au code de la route et à la loi. Le Conducteur et le Passager s'engagent également à ne transporter aucun objet ou substance illicite ou dangereux au cours du trajet commun.
                            </p>
                        </article>

                        <article class="charter-section">
                            <div class="section-header">
                                <h2 class="section-number">4.</h2>
                                <h2 class="section-title">Heures de départ</h2>
                            </div>
                            <p class="charter-paragraph section-content">
                                Les utilisateurs sont tenus de respecter les heures de départ convenues. Ils doivent se présenter au lieu et à l'heure prévus pour le rendez-vous. Passée une tolérance de 30 minutes après l'heure convenue, la personne qui ne s'est pas présentée est considérée comme responsable de l'annulation.
                            </p>
                        </article>

                        <article class="charter-section">
                            <div class="section-header">
                                <h2 class="section-number">5.</h2>
                                <h2 class="section-title">Informations publiées sur le site</h2>
                            </div>
                            <p class="charter-paragraph section-content">
                                Il est interdit aux Utilisateurs du Site de publier des propos diffamatoires, injurieux ou préjudiciables à des tiers. MyEcoCar se réserve le droit de supprimer toute information contraire à son image dès qu'elle lui aura été portée à sa connaissance. Les Conducteurs et les Passagers acceptent par avance la publication sur le Site d'avis les concernant.
                            </p>
                        </article>
                    </div>
                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.conduct-charter,
.app-container.conduct-charter main,
.app-container.conduct-charter #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.conduct-charter .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.conduct-charter .footer-component {
    display: none !important;
}
</style>

<style scoped>
.charter-page {
    background: #f6f9f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.charter-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.charter-hero-content {
    width: min(1400px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.charter-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.charter-container {
    width: min(1700px, 98vw);
    margin: 0 auto;
    padding: 54px 20px 28px;
    flex: 1;
}

.charter-content {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 10px;
    padding: 48px 68px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
}

.content-box {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.charter-intro {
    padding-bottom: 20px;
    border-bottom: 2px solid #aef7b9;
}

.charter-paragraph {
    margin: 0;
    font-size: 18px;
    line-height: 1.8;
    color: #34463c;
    font-family: 'Heebo', 'Poppins', sans-serif;
}

.charter-sections {
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.charter-section {
    padding-bottom: 24px;
    border-bottom: 1px solid #e3ebe5;
}

.charter-section:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.section-header {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 12px;
}

.section-number {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #2d5016;
    min-width: 40px;
    flex-shrink: 0;
}

.section-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #173726;
}

.section-content {
    padding-left: 0;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 2rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .charter-hero {
        padding: 50px 20px 40px;
    }

    .charter-title {
        font-size: 32px;
    }

    .charter-container {
        padding: 34px 12px 28px;
    }

    .charter-content {
        padding: 34px 28px;
    }

    .charter-paragraph {
        font-size: 16px;
        line-height: 1.7;
    }

    .section-number {
        font-size: 20px;
    }

    .section-title {
        font-size: 18px;
    }

    .section-content {
        padding-left: 0;
    }

    .footer-section {
        padding: 2rem 1rem 100px;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .charter-hero {
        padding: 40px 20px 30px;
    }

    .charter-title {
        font-size: 26px;
    }

    .charter-container {
        padding: 24px 12px;
    }

    .charter-content {
        padding: 20px 16px;
    }

    .content-box {
        gap: 24px;
    }

    .charter-paragraph {
        font-size: 14px;
        line-height: 1.6;
    }

    .section-header {
        gap: 8px;
    }

    .section-number {
        font-size: 18px;
        min-width: 30px;
    }

    .section-title {
        font-size: 16px;
    }

    .section-content {
        padding-left: 0;
        font-size: 13px;
    }

    .charter-sections {
        gap: 20px;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';

export default {
    name: 'conduct-charter',
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    methods: {
        onBackClick() {
            router.back();
        }
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
